<template>
  <div class="main" v-if="!loading">
    <div class="wrapPortable Indica">
      <h1 class="indH1">Vos Cours</h1>
    </div>

    <div class="exFav-section">
      <ul class="exFav">
        <li
          v-for="(video, index) in allVideo"
          :key="index"
          :id="index"
          v-on:click.prevent="creationIframe(index)"
        >
          <div class="liPart1">
            <img
              :src="
                infos !== null ? infos[index].info.link_picture : linkDefault
              "
              :alt="video.url"
              :id="'thumbImg' + index"
            /><!--""-->
            <Frame :id="index" :url="video.url"></Frame>
          </div>
          <div class="liPart2">
            <h2 v-if="infos !== null && infos[index].info.title !== null">
              {{ infos[index].info.title }}
            </h2>
            <h2 v-else>Exercice</h2>
            <p
              v-if="
                video.date !== null &&
                  video.date !== undefined &&
                  video.date !== 0
              "
            >
              Date dernière vue : {{ video.date }}
            </p>
            <p
              class="pDescription"
              v-if="
                infos !== null &&
                  infos[index].info.description !== null &&
                  click == true
              "
            >
              {{ infos[index].info.desc }}
            </p>
            <p
              :class="['pDescription', click === index && click !== false ? 'activeFrame' : 'hideFrame']"
            >
              Description
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="main  mainLoader" v-else>
    <circleLoader :when="loading"></circleLoader>
  </div>
</template>

<script>
import { User } from "../controller/user.js";
import Frame from "@/components/Frame";
import { hostUrl } from "../_helpers/global_var";
import circleLoader from "@/components/Circle-loader";
import * as tutos from "../controller/videoCours.js";

const axios = require("axios").default;

export default {
  name: "Favories",
  components: { Frame, circleLoader },
  data() {
    return {
      user: JSON.parse(localStorage.user) || [],
      allVideo: "",
      loading: true,
      url: "#",
      infos: null,
      linkDefault: "https://i.vimeocdn.com/video/957679804_200x150.jpg?r=pad",
      click: false
    };
  },
  watch: {
    loading() {
      if (
        this.allVideo !== undefined &&
        this.allVideo !== "" &&
        this.loading !== undefined
      ) {
        return (this.loading = false);
      } else {
        return (this.loading = true);
      }
    }
  },
  created() {
    if (typeof localStorage.user !== undefined && localStorage.length > 1) {
      if (localStorage.user.mail !== undefined) {
        this.user = JSON.parse(localStorage.user);
      }
      //console.log(this.user);
    } else {
      console.log("var not exist");
    }

    if (
      typeof localStorage.mesCours !== undefined &&
      localStorage.length > 2
    ) {
      try {
        let koko = JSON.parse(localStorage.mesCours)[0].url;
        this.allVideo = JSON.parse(localStorage.mesCours);
        //console.log(this.allVideo);
      } catch (error) {
        this.appelMesEx();
      }
    } else {
      this.appelMesEx();
    }
    try {
      this.getInfos(JSON.parse(localStorage.mesCours)).then(
        () => (this.infos = JSON.parse(localStorage.videoInfo))
      );
      this.getInfos(JSON.parse(localStorage.mesCours)).catch(
        () => (this.infos = null)
      );
    } catch (error) {
      this.infos = null;
    }
  },
  methods: {
    async appelMesEx() {
      //console.log(tutos.listCour()[0].url, tutos.listCour());
      if (tutos.listCour()[0].url == null){
      await axios
        .get(
          hostUrl +
            "/list_videoC/" +
            this.user
              .salarie_id /*, {withCredentials: true, headers: {'Access-Control-Allow-Origin': 'http://localhost:8080', 'Content-Type': 'application/x-www-form-urlencoded'}}*/
        )
        .then(
          response =>
            (localStorage.mesCours = JSON.stringify(response.data))
        )
        .then(() => (this.allVideo = JSON.parse(localStorage.mesCours)))
        .catch(error => console.log(error));

        return this.loading = false;
      }else{
        localStorage.mesCours = JSON.stringify(tutos.listCour());
        return this.loading = false;
      }
    },
    async getInfo(video_id) {
      let uri = hostUrl + "/vimeo/info/" + video_id;
      await axios
        .get(uri)
        .then(
          response => (localStorage.videoInfo = JSON.stringify(response.data))
        )
        .catch(error => console.log(error));
    },

    async getInfos(array) {
      let uri = hostUrl + "/vimeo/infos";
      let json = JSON.stringify(array);
      await axios
        .post(uri, json)
        .then(
          response => (localStorage.videoInfo = JSON.stringify(response.data))
        )
        .then(() => (this.loading = false))

        .catch(() => (localStorage.videoInfo = null))
        .catch(() => (this.loading = false))
        .catch(() => error => console.log(error));
    },
    creationIframe(idLi, url) {
      let frame = document.getElementById("frame" + idLi);
      let li = document.getElementById(idLi);
      if (frame.className == "hideFrame") {
        li.style.height = "360px";
        frame.className = "activeFrame";
        this.click = idLi;
      } else {
        this.click = false;
        frame.className = "hideFrame";
        li.style.height = "70px";
      }
    }
  },
  mounted() {
    if (this.allVideo !== undefined && this.allVideo !== "") {
      this.loading = false;
    }
    //console.log(tutos.listCour()[0].url, tutos.listCour());
  },
  computed: {
    loader() {
      if (
        this.allVideo !== undefined &&
        this.allVideo !== "" &&
        this.loading !== undefined
      ) {
        return (this.loading = false);
      } else {
        return (this.loading = true);
      }
    }
  }
};
</script>
<style>
.exFav {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: visible;
  font-family: "Myriad Pro Light";
  /*color: #484848;*/
}
.exFav li {
  height: 70px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  transition: height 0.8s, transform 1s linear;
  position: relative;
  /*overflow: visible;*/
}
.hideFrame {
  visibility: hidden;
  opacity: 0;
  transform: translateY(-20px);
  transition: visibility 1s, opacity 0.8s, transform 1s linear;
  /*position: absolute;   
    top: 30px;
    right: -32%;*/
}
.activeFrame {
  visibility: visible;
  opacity: 1;
  transform: translateY(10px);
  transition: visibility 1s, opacity 0.8s, transform 1.2s linear;
  /*position: absolute;
    top: 30px;
    left: -32%;*/
}
.liPart1 {
  height: 100%;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.liPart2 {
  height: 100%;
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}
.liPart2 h2,
.liPart2 p {
  margin: 0;
  padding: 0;
}
.pDescription {
  margin-top: 80px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Cours.vue